"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _i18next = _interopRequireDefault(require("i18next"));

var _reactI18next = require("react-i18next");

var _i18nextIntervalpluralPostprocessor = _interopRequireDefault(require("i18next-intervalplural-postprocessor"));

var _en = _interopRequireDefault(require("./en"));

_i18next["default"].use(_i18nextIntervalpluralPostprocessor["default"]).use(_reactI18next.initReactI18next).init({
  // we init with resources
  resources: {
    en: _en["default"]
  },
  lng: 'en',
  fallbackLng: 'en',
  debug: true,
  // have a common namespace used around the full app
  ns: ['translations'],
  defaultNS: 'translations',
  keySeparator: false,
  // we use content as keys
  interpolation: {
    escapeValue: false,
    format: function format(value, _format, lng) {
      if (_format === 'number') {
        return value.toLocaleString();
      }

      return;
    }
  }
});

var _default = _i18next["default"];
exports["default"] = _default;
//# sourceMappingURL=index.js.map